import { render, staticRenderFns } from "./BaseCollapse.vue?vue&type=template&id=7203820e&scoped=true&"
import script from "./BaseCollapse.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BaseCollapse.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BaseCollapse.vue?vue&type=style&index=0&id=7203820e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7203820e",
  null
  
)

export default component.exports